// @ts-nocheck
import { useEffect } from 'react';
import { handleOAuthSignIn, pollForMicrosoft } from './auth.utils';

export const MicrosoftOAuth = ({ propertyUrl }: {propertyUrl?: string}) => {
  useEffect(() => {
    if (!propertyUrl) {
      return;
    }

    const initializeMicrosoft = async () => {
      try {
        await pollForMicrosoft();

        if (document.cookie.includes('mm_auth_session')) {
          return;
        }

        window.ms.auth.initialize({
          client_id: 'af67ff77-17aa-478e-9d73-4a737f7b41ea',
          callback: (response: any, errorInfo: any) => {
            if (!response) {
              console.error('Microsoft OAuth error:', errorInfo);
              return;
            }
            // Extract the id_token from Quick Auth response
            if (response.idToken) {
              handleOAuthSignIn('microsoft', {
                credential: response.idToken,
              });
            } else {
              console.error('No idToken in Microsoft response:', response);
            }
          },
          login_uri: window.location.origin,
          partner_name: 'Sports Illustrated',
          cancel_on_tap_outside: false,
          prompt_position: 'right',
        });
      } catch (error) {
        console.error('Failed to initialize Microsoft OAuth:', error);
      }
    };

    initializeMicrosoft();
  }, [propertyUrl]);

  return null;
};
